import { GET_CAMPAIGN_ASYNC, INIT_EDIT_MODE } from './constants'

const initEditMode = (campaignId) => ({
  type: INIT_EDIT_MODE,
  payload: { campaignId },
})
export const getCampaignSuccess = (campaignType) => ({
  type: GET_CAMPAIGN_ASYNC.SUCCESS,
  payload: { campaignType },
})
export const getCampaignError = () => ({ type: INIT_EDIT_MODE.ERROR })

export default {
  initEditMode,
}
